import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import fun from "../assets/script/function";

import routes from './routes';

Vue.use(VueRouter);

const WHITE_LIST = ['/', '/login', '/mine', '/notice', '/notice_detail', '/manual', '/tacs_sso/callback'];

Vue.prototype.navigateTo = function(link, data, type = 'push') {
	if (typeof data == 'string') {
		type = data;
		data = undefined;
	}
	
	if (data) {
		var t = [];
		for (let key in data) {
			t.push(encodeURIComponent(key) + '=' + encodeURIComponent(typeof data[key] == 'object' ? JSON.stringify(data[key]) : data[key]));
		}
		link += '?' + t.join('&');
	}
	
	if (type == 'open') {
		if (link.indexOf('http') !== 0) {
			link = location.origin + location.pathname + location.search + this.$router.resolve(link).href;
		}
		window.open(link);
	} else if (type == 'clear') {
		this.$router.replace(link);
	} else {
		this.$router[type](link);
	}
};
Vue.prototype.navigateBack = function(n = -1) {
	this.$router.go(n);
};

const router = new VueRouter({
	mode: 'hash',
	base: '/',
	linkActiveClass: 'z-active',
	linkExactActiveClass: 'z-exact',
	routes
});

router.beforeEach((to, form, next) => {
	// 未登录账号重定向登录
	if (!fun.getCookie('session_id') && !WHITE_LIST.includes(to.path)) {
		next('/login');
		return;
	}
	if (fun.getCookie('session_id') && to.path.includes('/login')) {
		next('/');
		return;
	}
	
	// 未认证用户
	if (store.state.userInfo.user_type == -1 && !WHITE_LIST.includes(to.path)) {
		Vue.prototype.$confirm({
			text: '当前用户未绑定企业',
			message: '请联系本服务提供单位：平阳县交通运输局<br>联系电话：0577-63110290',
			buttonName: '我知道了',
			cancelButton: false
		});
		return;
	}
	
	// 未完善账号重定向完善资料
	if (store.state.userInfo.user_type === 0 && to.path != '/register' && !WHITE_LIST.includes(to.path)) {
		Vue.prototype.$confirm({
			text: '账户资料不完整',
			message: '您的账户资料不完整，请先完善资料',
			buttonName: '前往完善资料',
			cancelButton: false,
			resolve: () => {
				next('/register');
			}
		});
		return;
	}
	
	// 已完善账号重定向首页
	if (store.state.userInfo.user_type != 0 && to.path == '/register') {
		next('/');
		return;
	}
	
	next();
	window.scrollTo(0, 0);
});

export default router